export const PLATFROM_REG = {
  H5: /(nokia|iphone|android|ipad|motorola|^mot-|softbank|foma|docomo|kddi|up\.browser|up\.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jig\s browser|hiptop|^ucweb|^benq|haier|^lct|opera\s*mobi|opera\*mini|320x320|240x320|176x220)/i,
  Android: /android|adr/i,
  IOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/,
  Iphone: /iphone|ipod/i,
  Ipad: /ipad/i,
  Weixin: /MicroMessenger/i,
  WorkWeixin: /wxwork/i,
  QQBrowser: /QQBrowser|qq|qqtheme|mqqbrowser/i,
  Dingtalk: /dingtalk/i,
  Instagram: /instagram/i,
  Facebook: /fban|fbios|fbav/i,
  InTalkie: /talkie/i,
  IsSearchEngine: /googlebot|bingbot|yandex|baiduspider/i,
  Safari: /^(?!.*chrome|android).*(safari|applewebkit)/i,
  Mac: /macintosh/i,
};

export const isMobile = (userAgent: string | undefined) => {
  if (!userAgent) {
    return false;
  }
  return PLATFROM_REG.H5.test(userAgent);
};

export const isSearchEngine = (userAgent: string | undefined) => {
  if (!userAgent) {
    return false;
  }
  return PLATFROM_REG.IsSearchEngine.test(userAgent);
};
